import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('delta3series.recycling');
    const { locale } = useRouter();

    const configs = {
        title: t('A_title'),
        theme: 'black',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723615890195/recycling_PC.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723615903627/recycling_M.jpg',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...configs} />
        </div>
    );
}
